import NotificationsDialog from './NotificationsDialog.container';

export default NotificationsDialog;
